import styled from 'styled-components'

export const SubHeader = styled.div`
  color: #343e59;
  font-size: 14px;
  font-weight: 700;
  text-transform: capitalize;
`
export const LastContent = styled.div`
  margin-top: 30px;
  color: #b3b7c1;
  font-size: 13px;
  font-weight: 500;
`
